import type { Theme, Components } from '@mui/material/styles';
import { switchClasses } from '@mui/material/Switch';

import { CbridgePalette } from './theme.constant';

const states = CbridgePalette.switch;

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => {
      const onTrack = theme.palette.brand.switch;

      return {
        [`& .${switchClasses.switchBase}`]: {
          [`& + .${switchClasses.track}`]: {
            backgroundColor: states.off.main.track,
          },
          [`& .${switchClasses.thumb}`]: {
            color: states.off.main.thumb,
          },
        },
        [`& .${switchClasses.switchBase}.${switchClasses.disabled}`]: {
          [`& + .${switchClasses.track}`]: {
            backgroundColor: states.off.disabled.track,
            opacity: 1,
          },
          [`& .${switchClasses.thumb}`]: {
            color: states.off.disabled.thumb,
          },
        },

        [`& .${switchClasses.switchBase}.${switchClasses.checked}`]: {
          [`& + .${switchClasses.track}`]: {
            backgroundColor: onTrack.track,
          },
          [`& .${switchClasses.thumb}`]: {
            color: states.on.main.thumb,
          },
        },
        [`& .${switchClasses.switchBase}.${switchClasses.checked}.${switchClasses.disabled}`]: {
          [`& + .${switchClasses.track}`]: {
            backgroundColor: onTrack.disabledTrack,
            opacity: 1,
          },
          [`& .${switchClasses.thumb}`]: {
            color: states.on.disabled.thumb,
          },
        },

        '&:hover, &:focus': {
          [`& .${switchClasses.switchBase}:not(.${switchClasses.disabled})`]: {
            [`& + .${switchClasses.track}`]: {
              backgroundColor: states.off.active.track,
            },
            [`& .${switchClasses.thumb}`]: {
              color: states.off.active.thumb,
            },
          },

          [`& .${switchClasses.switchBase}.${switchClasses.checked}:not(.${switchClasses.disabled})`]: {
            [`& + .${switchClasses.track}`]: {
              backgroundColor: onTrack.track,
            },
            [`& .${switchClasses.thumb}`]: {
              color: states.on.active.thumb,
            },
          },
        },
      };
    },

    track: {
      opacity: 1,
    },
  },
};
